document.addEventListener("DOMContentLoaded", function() {
  let legalModal = document.getElementById("legal-modal");
  let privacyModal = document.getElementById("privacy-modal");
  let legalLink = document.getElementById("legal-link");
  let privacyLink = document.getElementById("privacy-link");
  let closeLegal = document.getElementById("close-legal");
  let closePrivacy = document.getElementById("close-privacy");

  legalLink.onclick = function(event) {
    event.preventDefault();
    legalModal.style.display = "block";
  }

  privacyLink.onclick = function(event) {
    event.preventDefault();
    privacyModal.style.display = "block";
  }

  closeLegal.onclick = function() {
    legalModal.style.display = "none";
  }

  closePrivacy.onclick = function() {
    privacyModal.style.display = "none";
  }

  window.onclick = function(event) {
    if (event.target == legalModal) {
      legalModal.style.display = "none";
    }
    if (event.target == privacyModal) {
      privacyModal.style.display = "none";
    }
  }
});
